import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlight',
    standalone: true
})
export class HighlightPipe implements PipeTransform {
  transform(text: string, findValue: string) {
    if (text) {
      if (text.toLowerCase().includes(findValue.toLowerCase())) {
        const pattern = new RegExp(findValue, 'gi');
        const str = text.replace(pattern, `<span class="keyword">` + findValue + `</span>`);
        return str;
      } else {
        return text;
      }
    } else {
      return 
    }
    
  }
}
